import  React, {useEffect, useState} from "react";
import '../Editor/editor.css';
import ReactHtmlParser from 'react-html-parser'

const LPPHeightView = 850
const DTPHeightView = 550

export default function Viewer({ objects, standardType }) {
    const svgRef = React.createRef();  
    const mediatoken = localStorage.getItem('mediatoken');
    const [svg, setSvg] = useState(null);

    useEffect(() => {        
        const newsvg = objects.filter((e) => {
            return e.type === 'svg';
        });
   
      (newsvg && newsvg.length > 0) && setSvg(newsvg[0].svg);
    },[])

function renderCirc (obj) {
    let x, y, w, h;

    if (obj.xStart < obj.xEnd) {
      x = obj.xStart;
      w = obj.xEnd - obj.xStart;
    } else {
      x = obj.xEnd;
      w = obj.xStart - obj.xEnd;
    }

    if (obj.yStart < obj.yEnd) {
      y = obj.yStart;
      h = obj.yEnd - obj.yStart;
    } else {
      y = obj.yEnd;
      h = obj.yStart - obj.yEnd;
    }

    const r = Math.min(h / 2, w / 2);
    const rx = obj.locked ? r : w / 2;
    const ry = obj.locked ? r : h / 2;
    const bg = (obj.id > 1634601600000)  ? obj.bg : "red";

    return (
      <ellipse
        key={obj.id}
        cx={x + rx}
        cy={y + ry}
        rx={rx}
        ry={ry}
        stroke={bg}
        strokeWidth = {3}
        fill= "rgba(0,0,0,0)"

      />
    );
  }

  function renderText (obj) {
    const divid = "d"+obj.id;
    const bg = ('bg' in obj) ? obj.bg : "black";
    const textStyle = (obj.id > 1634601600000)  ?
      { wordWrap: 'break-word', whiteSpace:'pre-wrap', width: obj.width, height: obj.height, display: 'inline-block', color: bg, fontSize: obj.fontSize, fontWeight: obj.fontWeight }
      :
      { whiteSpace:'pre', fontSize: obj.fontSize, fontWeight: obj.fontWeight }

    return (
      <foreignObject
        key={obj.id}
        x = {obj.xStart}
        y = {obj.yStart}  
        width = {'250px'}
        height = {'50px'}

        style={{overflow:'visible'}}
      >    
       <div id={divid} 
               style={textStyle}
              >
          {obj.text}
        </div>

      </foreignObject>
    )
  }

function  renderArrow (obj) {
    let d = Math.abs(obj.xStart - obj.xEnd) + Math.abs(obj.yStart - obj.yEnd);
    const bg = ('bg' in obj) ? obj.bg : "red";
    if (d>10) {
      return (
        <g key={'a' + obj.id} >
          <marker id={"triangle"+obj.id}
            viewBox="0 0 10 10" refX="0" refY="5" 
            markerUnits="strokeWidth"
            markerWidth="5" markerHeight="4"
            fill={bg}
            orient="auto">
            <path d="M 0 0 L 10 5 L 0 10 z" />
          </marker>
          <line
              key={obj.id}
              x1 = {obj.xStart}
              y1 = {obj.yStart}  
              x2 = {obj.xEnd}
              y2 = {obj.yEnd}           
              stroke = {bg}
              strokeWidth = "3" 
              markerEnd={"url(#triangle" + obj.id + ")"}

          />    
        </g>
      )
    }
  }

  function renderImg (obj) {
    return (
      <image
          preserveAspectRatio="xMinYMin meet"
          key={obj.id}
          x = {obj.xStart}
          y = {obj.yStart}  
          width = {obj.width}
          height = {obj.height}
          //href = "https://mdn.mozillademos.org/files/6457/mdn_logo_only_color.png"
          // href={(obj.src + addToken())} //{localStorage.getItem(obj.src) ?? ''}
          xlinkHref={`${(obj.src + addToken())}`} //{localStorage.getItem(obj.src) ?? ''}
      />    

    )

    }

    function addToken() {
        return '?' + mediatoken
    }

    function renderRect (obj) {
      let x, y, w, h;

      if (obj.xStart < obj.xEnd) {
        x = obj.xStart;
        w = obj.xEnd - obj.xStart;
      } else {
        x = obj.xEnd;
        w = obj.xStart - obj.xEnd;
      }

      if (obj.yStart < obj.yEnd) {
        y = obj.yStart;
        h = obj.yEnd - obj.yStart;
      } else {
        y = obj.yEnd;
        h = obj.yStart - obj.yEnd;
      }

      const size = Math.min(w, h);
      const bg = ('bg' in obj) ? obj.bg : "red";
      return (
        <rect
          key={obj.id}
          x={x}
          y={y}
          width={obj.locked ? size : w}
          height={obj.locked ? size : h}
          stroke= {bg}
          strokeWidth = {3}
          fill= "rgba(0,0,0,0)"

        />
      );
    }

    function viewerHeightSize() {
        switch (standardType) {
            case 'lpp':
                return LPPHeightView;
            case 'dtp':
                return DTPHeightView;
            default:
                return 850;
        }
    }
   
    return (        
        <div className="canvas h-100 w-100" id="contentPDF" style={{ width: '650px', overflow: "auto", height: (viewerHeightSize().toString()+'px')}} >        
      
        { (false && svg) ? ReactHtmlParser (svg) :

           <svg 
              ref={svgRef}
              style={{touchAction: 'none'}}
              width='100%'
              viewBox={`0 0 650 ${viewerHeightSize()}`}
              preserveAspectRatio="xMidYMid meet"
              >
            {objects.map(o => {
              if (o.type === "rect") {
                return renderRect(o);
              }

              if (o.type === "circ") {
                return renderCirc(o);
              }

              if (o.type === "text") {
                return renderText(o);
              }

              if (o.type === "img") {
                return renderImg(o);
              }

              if (o.type === "arrow") {
                return renderArrow(o);
              }

              if (o.type === "svg") {
                return ""
              }

              return null;
            })}
          </svg> 
          
           }
      </div>
    );

  }